<app-popup-layout #modal>
  <div class="container m-0 p-0">
    <div class="row m-0 p-0">
      <div class="col-sm-6 m-0 p-0">
        <img class="restriction-img" src="/assets/images/manual-expense-restriction.svg" alt="Expense Restriction" />
      </div>
      <div class="col-sm-6 m-0 p-0 d-flex flex-column">
        <section class="content-section d-flex flex-column">
          <app-close-button class="ms-auto" (onCloseEmitter)="modal.dismiss()"></app-close-button>
          <section>
            <h2 class="title">Expense Submission Disabled!</h2>
            <p class="message">
              The company has disabled expense
              reimbursement filing. Contact your admin to get it enabled.
            </p>
          </section>
        </section>
      </div>
    </div>
  </div>
</app-popup-layout>